<header class="site-header" [class.scrolled]="isScrolled">
  <div class="container header-inner">
    <div class="header-start">
      <button
        class="hamburger"
        type="button"
        (click)="toggleMenu()"
        [attr.aria-expanded]="menuOpen"
        aria-label="Toggle navigation"
      >
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M4 6h16M4 12h12M4 18h16"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
          />
        </svg>
      </button>

      <a class="brand" routerLink="/" (click)="onLogoClick()">
        <img [src]="logoSrc" alt="Tricore Holdings logo" />
        <div class="brand-text">
          <span class="brand-title">Tricore Holdings</span>
          <span class="brand-subtitle">Pvt. Ltd.</span>
        </div>
      </a>
    </div>

    <div class="capsule" aria-label="Primary navigation">
      <button
        class="section-btn"
        type="button"
        *ngFor="let section of sections"
        (click)="onSectionClick(section.id)"
        [class.is-active]="scrollSpy.isActive(section.id)"
      >
        {{ section.label }}
      </button>
    </div>

     <div class="header-actions">
       <a
         class="contact-pill"
         routerLink="/contact-us"
         routerLinkActive="is-active"
       >
         <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
           <path
             d="M490.67-472.67v-334q0-14.16 9.58-23.75Q509.83-840 524-840h282.67q14.16 0 23.75 9.58 9.58 9.59 9.58 23.75V-612q0 14.17-9.58 23.75-9.59 9.58-23.75 9.58H600l-109.33 106Zm66.66-172.66h216v-128h-216v128Zm0 0v-128 128ZM796-120q-119 0-240-55.5T333-333Q231-435 175.5-556T120-796q0-18.86 12.57-31.43T164-840h147.33q14 0 24.34 9.83Q346-820.33 349.33-806l26.62 130.43q2.05 14.9-.62 26.24-2.66 11.33-10.82 19.48L265.67-530q24 41.67 52.5 78.5T381-381.33q35 35.66 73.67 65.5Q493.33-286 536-262.67l94.67-96.66q9.66-10.34 23.26-14.5 13.61-4.17 26.74-2.17L806-349.33q14.67 4 24.33 15.53Q840-322.27 840-308v144q0 18.86-12.57 31.43T796-120ZM233-592l76-76.67-21-104.66H187q3 41.66 13.67 86Q211.33-643 233-592Zm365.33 361.33q40.34 18.34 85.84 29.67 45.5 11.33 89.16 13.67V-288l-100-20.33-75 77.66ZM233-592Zm365.33 361.33Z"
             fill="currentColor"
           />
         </svg>
         <span>Contact Us</span>
       </a>
    </div>
  </div>

  <div class="menu-overlay" [class.is-open]="menuOpen" (click)="closeMenu()"></div>
  <aside class="side-drawer" [class.is-open]="menuOpen">
    <div class="drawer-header">
      <span>Menu</span>
      <button class="drawer-close" type="button" (click)="closeMenu()">
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
        </svg>
      </button>
    </div>
    <div class="drawer-section">
      <p class="drawer-title">Explore</p>
      <button
        class="drawer-link"
        type="button"
        *ngFor="let section of sections"
        (click)="onSectionClick(section.id); closeMenu()"
        [class.is-active]="scrollSpy.isActive(section.id)"
      >
        {{ section.label }}
      </button>
    </div>
    <div class="drawer-section">
      <a class="drawer-link" routerLink="/faq" (click)="closeMenu()">FAQ</a>
    </div>
  </aside>
</header>

